import {ProtocolDto} from "../dtos/protocol.dto";
import {ActivityDto} from "../dtos/activity.dto";

export class SessionViewModel {
    constructor(public readonly protocol: ProtocolDto,
                public readonly activity: ActivityDto,
                public readonly date: Date) {
    }
}
